import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack'
import {
  API_BASE_URL,
  mergeHooks,
  onApiRequest,
  onApiRequestError,
  onApiResponse,
  onApiResponseError,
} from '~/utils/apiInterceptors'

export type ApiFetchOptions = NitroFetchOptions<NitroFetchRequest> & {
  /** 失败时不弹 toast（埋点等旁路请求） */
  skipErrorToast?: boolean
  /** 公开接口：不附带 Bearer，401 仅 toast 不自动退出 */
  skipAuth?: boolean
  /** 不计入全局 loading（后台轮询等静默请求） */
  skipGlobalLoading?: boolean
}

const client = $fetch.create({
  baseURL: API_BASE_URL,
  retry: false,
})

export function apiFetch<T>(path: NitroFetchRequest, options?: ApiFetchOptions): Promise<T> {
  return client<T>(path, {
    ...options,
    onRequest: mergeHooks(onApiRequest, options?.onRequest),
    onRequestError: mergeHooks(onApiRequestError, options?.onRequestError),
    onResponse: mergeHooks(onApiResponse, options?.onResponse),
    onResponseError: mergeHooks(onApiResponseError, options?.onResponseError),
  })
}

/** 登录 / 发码 / 找回密码等公开接口 */
export function publicApiFetch<T>(path: NitroFetchRequest, options?: ApiFetchOptions): Promise<T> {
  return apiFetch<T>(path, { ...options, skipAuth: true })
}
